<script>
  import { Link } from 'svelte-navigator';
  import { onMount } from 'svelte';
  import Button from '../components/Button.svelte';
  import Modal from '../components/Modal.svelte';
  import ArrowRight from '../assets/images/icon-arrow-right.svelte';
  import InfoIcon from '../assets/images/icon-info.svelte';
  import Fer from '../Fer.js';

  const labels = ['neutral', 'smile', 'surprised', 'disgust', 'scream'];

  const shuffle = (array) => {
    return array.sort(() => Math.random() - 0.5);
  };

  const modulo = (array, N) => {
    return array.map((item) => item % N);
  };

  const flowerData = {
    lottieFlowers: shuffle([
      '/lotties/flowers/tulip-blue-sparkles.json',
      '/lotties/flowers/tulip-orange-sparkles.json',
      '/lotties/flowers/tulip-yellow-sparkles.json',
      '/lotties/flowers/poppy-blue-sparkles.json',
      '/lotties/flowers/poppy-red-sparkles.json',
      '/lotties/flowers/rose-red-sparkles.json',
      '/lotties/flowers/rose-pink-sparkles.json',
      '/lotties/flowers/rose-yellow-sparkles.json',
    ]),
    potNames: [
      'NEUTRAL',
      'SMILE',
      'SURPRISE',
      'DISGUST',
      'ANGER',
    ],
    pots: [
      '/SVG/flowerpot-neutral.svg',
      '/SVG/flowerpot-smile.svg',
      '/SVG/flowerpot-surprise.svg',
      '/SVG/flowerpot-disgust.svg',
      '/SVG/flowerpot-anger.svg',
    ],
    potAlts: [
      'Flowerpot Neutral',
      'Flowerpot Smile',
      'Flowerpot Surprise',
      'Flowerpot Disgust',
      'Flowerpot Anger',
    ],
  };

  // The order of the flowerpots is shuffled to make it more interesting and random for the user
  let potsOrder = [...Array(flowerData.pots.length).keys()];
  // but always start with smile
  potsOrder.splice(potsOrder.indexOf(1), 1);
  potsOrder = [1, ...shuffle(potsOrder)];

  

  const flowersOrder = modulo(
    [...Array(flowerData.pots.length).keys()],
    flowerData.lottieFlowers.length
  );

  let isShownInfo;
  const setIsShownInfo = (bool) => {
    isShownInfo = bool;
  };
  const touch = () => {
    if (isShownInfo) {
      setIsShownInfo(false);
    } else {
      setIsShownInfo(true);
    }
  };

  let video_input;
  let progress;
  let fer;
  let faceControl = 'none';

  let gameStarted = false;
  let introModalVisible = true;
  let outroModalVisible = false;

  // timings
  let current_frame = 0;
  let max_frames = 0;
  let pct_frames = 0;
  let last_frame = 0;
  let every_x_frame = 2;
  let framerate_count = 0;
  let index = 0;
  let score = 0;
  const max_score = 10;
  let path = flowerData.lottieFlowers[flowersOrder[index]];

  let elem;
  let anim;

  const play = () => {
    if (anim !== undefined) {
      anim.play();
    }
  };
  const pause = () => {
    if (anim !== undefined) {
      anim.pause();
    }
  };

  const calc_pct_frames = (current_frame, max_frames) => {
    let local_pct_frames = (100 * current_frame / max_frames).toFixed(0);
    if (isNaN(local_pct_frames)) {
      local_pct_frames = 0;
    }
    return local_pct_frames;
  };

  const updateLoop = () => {
    if(gameStarted){
      const this_frame = performance.now() / 1000;
      const dt = this_frame - last_frame;
      last_frame = this_frame;

      if (faceControl === labels[potsOrder[index]]) {
        play();
      } else {
        pause();
      }
      current_frame = anim.currentFrame;
      max_frames = anim.getDuration(true);
      pct_frames = calc_pct_frames(current_frame, max_frames);
      progress.style.width = pct_frames + '%'; 
    }
    requestAnimationFrame(updateLoop);
  };

  const complete = () => {
    score = score + 1;
    if (score === max_score) {
      outroModalVisible = true;
      gameStarted = false;
    } else {
      index = (index + 1) % flowerData.pots.length;
      path = flowerData.lottieFlowers[flowersOrder[index]];
      detachLottie();
      attachLottie();
    }
  };
  const eventListeners = [{ eventName: 'complete', callback: complete }];

  const registerEvents = (eventListeners) => {
    eventListeners.forEach((eventListener) => {
      anim.addEventListener(eventListener.eventName, eventListener.callback);
    });
  };

  const deregisterEvents = (eventListeners) => {
    eventListeners.forEach((eventListener) => {
      anim.removeEventListener(eventListener.eventName, eventListener.callback);
    });
  };

  const attachLottie = () => {
    anim = lottie.loadAnimation({
      container: elem,
      path: path,
      renderer: 'svg',
      loop: false,
      autoplay: false,
    });

    registerEvents(eventListeners);
  };

  const detachLottie = () => {
    deregisterEvents(eventListeners);
    anim.destroy();
  };

  const startGame = () => {
    gameStarted = true;
    introModalVisible = false;
    outroModalVisible = false;
  };

  const playAgain = () => {
    score = 0;
    index = 0;
    potsOrder = [...Array(flowerData.pots.length).keys()];
    startGame();
  };

  onMount(() => {
    const cam = new Camera(video_input, {
      facingMode: 'user',
      width: 1280,
      height: 720,
      onFrame: async () => {
        if (framerate_count % every_x_frame == 0) {
          faceControl = await fer.getExpression(video_input, 1280, 720);
        }
        framerate_count += 1;
      },
    });

    fer = Fer.getInstance();
    fer.setupTf().then(() => {
      cam.start();
    });

    // cam.start()
    attachLottie();

    updateLoop();
  });
</script>

<div class="flowers">
  <main class="flowers__main">
    <div class="flowers__wrapper">
      <div class="flowers__wrapper--flower">
        <div bind:this={elem} />
      </div>
      <figure class="flowers__wrapper--pot">
        <img
          src={flowerData.pots[potsOrder[index]]}
          alt={flowerData.potAlts[potsOrder[index]]}
        />
      </figure>
      <div class="flowers__wrapper--progress">
        <div bind:this={progress} class="flowers__wrapper--progress-bar" style="width:0%"></div>
      </div>
      <div class="flowers__wrapper--progress-text">{flowerData.potNames[potsOrder[index]]} {pct_frames} %</div>
    </div>
  </main>
  <footer class="flowers__footer">
    <div class="flowers__footer--camera">
      <div class="cam">
        <video
          class="camera"
          style="transform: scaleX(-1);"
          bind:this={video_input}
        >
          <track kind="captions" srclang="en" label="english_captions" />
        </video>
      </div>
    </div>
    <div class="flowers__footer--score">
      <span>{score}</span>
    </div>
  </footer>
  <Link to="/games">
    <button class="btn-arrow">
      <ArrowRight />
    </button>
  </Link>
  <button
    on:mouseleave={() => setIsShownInfo(false)}
    on:mouseenter={() => setIsShownInfo(true)}
    on:touchstart={() => touch()}
    class='btn-info'
  >
    <InfoIcon />
  </button>

  {#if introModalVisible}
    <Modal hasHeader={true}>
      <div slot="header">Task</div>
      <div class="flowers__modaltext" slot="content">
        <h4>Make 10 flowers bloom</h4>
      </div>
      <div class="flowers__hero--btn" slot="buttons">
        <Button
          buttonSize="btn--xlarge"
          buttonStyle="btn--primary--solid"
          on:click={() => startGame()}
        >
          PLAY
        </Button>
      </div>
    </Modal>
  {/if}

  {#if outroModalVisible}
    <Modal hasHeader={true}>
      <div slot="header">Task Complete</div>
      <div class="flowers__modaltext" slot="content">
        <h4>Way to GROW!</h4>
      </div>
      <div class="flowers__hero--btn" slot="buttons">
        <Button
          buttonSize="btn--xlarge"
          buttonStyle="btn--primary--solid"
          on:click={() => playAgain()}
        >
          PLAY AGAIN
        </Button>
        <Link to="/games">
          <Button
            buttonSize="btn--xlarge"
            buttonStyle="btn--primary--solid"
          >
            MENU
          </Button>
        </Link>
      </div>
    </Modal>
  {/if}

  <div>
    {#if isShownInfo}
      <div class="info">
        <h4>Make 10 flowers bloom with the displayed facial expression</h4>
        <div class="info__expression flex flex-ai-c ">
          <img src="/emojis/neutral.png" alt="Neutral emoji" />
          <div class="info__expression--text  ">
            <h2>NEUTRAL</h2>
          </div>
        </div>
        <div class="info__expression flex flex-ai-c ">
          <img src="/emojis/smile.png" alt="Smile emoji" />
          <div class="info__expression--text  ">
            <h2>SMILE</h2>
          </div>
        </div>
        <div class="info__expression flex flex-ai-c ">
          <img src="/emojis/surprise.png" alt="Surprise emoji" />
          <div class="info__expression--text  ">
            <h2>SURPRISE</h2>
          </div>
        </div>
        <div class="info__expression flex flex-ai-c ">
          <img src="/emojis/disgust.png" alt="Disgust emoji" />
          <div class="info__expression--text  ">
            <h2>DISGUST</h2>
          </div>
        </div>
        <div class="info__expression flex flex-ai-c ">
          <img src="/emojis/anger.png" alt="Anger emoji" />
          <div class="info__expression--text  ">
            <h2>ANGER</h2>
          </div>
        </div>
        <p>
          <strong>Note:</strong> The facial detection is not perfect. Play in good
          lighting conditions and try with variations of your facial expressions
          :-)
        </p>
      </div>
    {/if}
  </div>
</div>
